module.exports = __webpack_public_path__ + "static/media/21ECLAC42.226da43f.jpg";